<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="搜索关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="loadData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="success" @click="addInfo">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      :data="infoList"
      style="width: 100%"
      row-key="id"
      border
      lazy>
      <el-table-column prop="id" label="ID" min-width="50"></el-table-column>
      <el-table-column prop="loginName" label="登入账号" min-width="120"></el-table-column>
      <el-table-column prop="name" label="中文名称" min-width="120"></el-table-column>
      <el-table-column prop="mobile" label="手机" min-width="120"></el-table-column>
      <el-table-column prop="loginIp" label="最后登录IP" min-width="120"></el-table-column>
      <el-table-column prop="lastLoginTime" label="最后登录时间" min-width="120"></el-table-column>
      <el-table-column label="推送" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="primary" v-show="scope.row.wechatOpenId"
                     @click="pushWechat(scope.row.wechatOpenId)">微信</el-button>
<!--          <el-button type="primary" @click="resetPassword(scope.row.id)">邮箱</el-button>-->
        </template>
      </el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" align="center" min-width="300">
        <template slot-scope="scope">
          <el-button type="primary" @click="authorize(scope.row)">授权</el-button>
          <el-button type="info" @click="resetPassword(scope.row.id)">重置密码</el-button>
          <el-button type="warning" @click="modifyInfo(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <PageGroup v-bind:pageInfo="pageInfo" @pageChange="loadData"></PageGroup>

    <!--新增界面-->
    <el-dialog title="记录" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
      <el-form :model="addFormData" ref="addFormData" label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="userName" label="登入账号：">
              <el-input type="text" v-model.trim="addFormData.loginName" placeholder="登入账号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="personName" label="中文名称：">
              <el-input type="text" v-model.trim="addFormData.name" placeholder="中文名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="phone" label="手机号码：">
              <el-input type="text" v-model.trim="addFormData.mobile" placeholder="手机号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click.native="addSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!--授权界面-->
    <el-dialog title="授权角色" :visible.sync="authDialogVisible" width="30%" :close-on-click-modal="false">
      <el-form label-width="150px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="roleIds" label="请选择角色：">
              <el-tree
                :data="tree"
                show-checkbox
                node-key="id"
                ref="tree"
                :default-checked-keys="checkKeys"
                :props="defaultProps"
                style="padding-top:10px"
              >
              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="authDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click.native="authSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {sysApi} from '../../api/index';
import axios from 'axios';
import {HttpResp} from "../../constant";
import PageGroup from "../template/PageGroup";

export default {
    name: 'SysUser',
    components: {PageGroup},
    data() {
        return {
          //查询列表
          filters: {
            name: ''
          },
          infoList: [],

          pageInfo: {
            pageNumber: 1, //默认在第一页
            pageSize: 10, //默认每页显示1条数据
            total: 1, //默认总条数为一条
          },

          //新增框
          dialogVisible: false,
          addFormData: {
            id: '',
            loginName: '',
            name: '',
            mobile: '',
          },
          //树形菜单属性。
          tree: [],
          checkKeys:[],
          defaultProps: {
            children: 'children',
            label: 'name'
          },

          //授权页面
          authDialogVisible: false,
          authUserId: '',
        }
    },
    mounted: function () {
        this.loadData();
    },
    methods: {
        addInfo() {
          this.addFormData = {
            id: '',
            loginName: '',
            name: '',
            mobile: '',
          };
          this.dialogVisible = true;
        },
        authorize(rowData) {
          this.authDialogVisible = true;
          this.authUserId = rowData.id;
          //加载菜单树
          this.tree = this.getRoles(rowData.id);
        },
        // 微信推送
        pushWechat(wechatOpenId) {
          let param = {
            "openid": wechatOpenId
          }
          sysApi.pushWechat(param).then(data => {
            if(data.code === HttpResp.SUCCUSS){
              this.$message({
                type: 'success',
                message: '推送成功'
              });
            }else{
              this.$message({
                type: 'info',
                message: `查询数据失败`
              });
            }
          });
        },
        modifyInfo(rowData) {
          this.addFormData = {
            id: rowData.id,
            loginName: rowData.loginName,
            name: rowData.name,
            mobile: rowData.mobile,
          }
          this.dialogVisible = true;
        },

        //列表数据加载
        loadData() {
            let param = {
              pageNumber: this.pageInfo.pageNumber,
              pageSize: this.pageInfo.pageSize,
              loginName: this.filters.name
            };

            sysApi.pageAdmin(param).then(data => {
              if(data.code == HttpResp.SUCCUSS){
                this.infoList = data.data.dataList;
                this.pageInfo.count = data.data.total;
              }else{
                this.$message({
                  type: 'error',
                  message: data.message
                });
              }
            })
        },
        getPages() {
            this.loadData();
        },
        //增加或修改
        addSubmit() {
          //先判断表单是否通过了判断
          this.$refs.addFormData.validate((valid) => {
            //代表通过验证 ,将参数传回后台
            if (valid) {
              let param = Object.assign({}, this.addFormData);
              sysApi.addAdmin(param).then(data => {
                if(data.code == HttpResp.SUCCUSS){
                  this.$message({
                    type: 'success',
                    message: '保存成功',
                  });
                  this.loadData();
                }else{
                  this.$message({
                    type: 'error',
                    message: data.message
                  });
                }
                this.dialogVisible = false;
              })
            }
          });
        },
        //授权
        authSubmit() {
          //先判断表单是否通过了判断
          let data = {
            id: this.authUserId,
            roleIds:this.$refs.tree.getCheckedKeys()
          };
          sysApi.saveAdminRole(data).then(data => {
            if (data.code === HttpResp.SUCCUSS) {
              this.$message({
                type: 'success',
                message: '保存成功',
              });
              this.authDialogVisible = false;
            } else {
              this.$message({
                type: 'error',
                message: data.message,
              });
            }
            this.dialogVisible = false;
          });
        },
        //重置密码
        resetPassword(userId) {
          this.$confirm('确定重置密码？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            sysApi.resetPassword(userId).then(data => {
              if(data.code == HttpResp.SUCCUSS){
                this.$message({
                  type: 'info',
                  message: `密码已重置`
                });
              }else{
                this.$message({
                  type: 'error',
                  message: data.message
                });
              }
            })
          })
        },
        //获取角色菜单
        getRoles(adminId) {
          sysApi.listRole().then(data => {
            if(data.code === HttpResp.SUCCUSS){
              this.tree = data.data.dataList;
            }else{
              this.$message({
                type: 'info',
                message: `查询数据失败`
              });
            }
          });
          sysApi.listRoleIdByAdminId(adminId).then(data => {
            if(data.code === HttpResp.SUCCUSS){
              //已选项
              this.checkKeys = data.data;
            }else{
              this.$message({
                type: 'info',
                message: `查询数据失败`
              });
            }
          });
        },
      }
}
</script>



// WEBPACK FOOTER //
// src/components/sys/SysUser.vue